import React, { useState, useEffect } from 'react';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useOnboarding } from '@sde/widgets-core/src/redux/resources/onboarding';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { formatter } from '@uhg-abyss/web/tools/formatter';
import isEqual from 'lodash/isEqual';
import { useModal } from 'src/state/modal';

const StyledCheckboxContainer = styled('div', {
  marginLeft: '20px',
});

export const ReactivateTrainingTipModal = () => {
  const { user } = useUser.state();
  const { setOnboarding } = useOnboarding.actions();
  const { tooltips } = useOnboarding.state();
  const [checkboxes, setCheckboxes] = useState({});
  const { modals } = useModal.state();
  const { toggleModal } = useModal.actions();

  useEffect(() => {
    setCheckboxes(tooltips);
  }, [tooltips]);

  const handleClose = () => {
    toggleModal({
      key: 'training-modal',
      isOpen: false,
    });
  };
  const toggleCheckbox = (e, appKey) => {
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [appKey]: e.target.checked,
    }));
  };

  const handleSubmit = () => {
    if (isEqual(tooltips, checkboxes)) {
      handleClose();
    } else {
      setOnboarding({ uuid: user.uuid, tooltips: checkboxes }, () => {
        toggleModal({
          key: 'training-modal',
          isOpen: false,
        });
        toggleModal({
          key: 'confirmation-modal',
          isOpen: true,
        });
      });
    }
  };

  const getLabel = (appKey) => {
    let label = '';
    switch (appKey) {
      case 'trackit':
        label = 'TrackIt';
        break;
      case 'documentLibrary':
        label = 'Document Library';
        break;
      case 'DLTeamsView':
        label = 'Document Library Teams View';
        break;
      case 'digisec':
        label = 'Manage Users';
        break;
      default:
        label = formatter('capitalCase', appKey);
    }
    return label;
  };

  return (
    <React.Fragment>
      <Modal
        id="reactivate-training-modal"
        isOpen={modals['training-modal']}
        onClose={handleClose}
        title="Please select features you want training tips reactivated for."
        footer={
          <Modal.Section>
            <Layout.Group alignLayout="center" space={30}>
              <Button
                id="close-button"
                aria-label="Click to cancelling reactivating the trainings tips"
                onClick={handleClose}
                variant="outline"
              >
                Cancel
              </Button>
              <Button
                id="close-button"
                aria-label="Click to reactivate the trainings tips"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Layout.Group>
          </Modal.Section>
        }
        css={{
          'abyss-modal-content-container': {
            width: '600px',
            top: '-50px',
          },
          'abyss-modal-body': {
            borderTop: `1px solid $gray4`,
          },
        }}
      >
        <Modal.Section>
          <StyledCheckboxContainer>
            <p>
              Select any of the features below to view training tips.
              <br /> You are able to select more than one.
            </p>
            <For each="appKey" of={Object.keys(tooltips)}>
              <If condition={!tooltips[appKey]}>
                <Checkbox
                  key={appKey}
                  label={getLabel(appKey)}
                  isChecked={checkboxes[appKey]}
                  data-testid={`reactivate-trainingtips-toggle-select-${appKey}`}
                  onChange={(e) => toggleCheckbox(e, appKey)}
                />
              </If>
            </For>
          </StyledCheckboxContainer>
        </Modal.Section>
      </Modal>
    </React.Fragment>
  );
};
